import styled, { from } from 'theme';

export const PageWrapper = styled.div`
  padding: 1rem;

  ${from('md')} {
    padding: 2rem;
  }

  ${from('xlg')} {
    padding: 4rem 5rem 4rem 4rem;
  }

  .applications__column {
    margin-bottom: 2rem;
  }

  ${from('xlg')} {
    .applications__column:nth-child(odd) {
      .application {
        margin-right: 1rem;
      }
    }

    .applications__column:nth-child(even) {
      .application {
        margin-left: 1rem;
      }
    }
  }
`;
